import { Component, Input, OnChanges } from "@angular/core";
import {
  UCCFilingData,
  HorizontalListData,
  DEFAULT_UCC_FILING_DATA,
  CommonActionKey,
  MessageService,
  SimpleDialogComponent,
  EntityAPIFacade
} from "common";
import {
  EntityUCCFilingWidgetAdapter,
  getInitializeUCC1DialogData,
  PROVISIONAL_UCC_FILING_DOCUMENT,
  UCCFilingDocumentLabels,
  UCCFilingStatusLabels,
} from "./entity-ucc-filing-widget.data";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "ifb-entity-ucc-filing-widget",
  styleUrls: ["./entity-ucc-filing-widget.component.scss"],
  templateUrl: "./entity-ucc-filing-widget.component.html",
  providers: [EntityUCCFilingWidgetAdapter],
  standalone: false,
})
export class EntityUCCFilingWidgetComponent implements OnChanges {
  @Input()
  uccFiling: UCCFilingData;

  @Input()
  canResubmitUCC: boolean;

  @Input()
  entityId: number;

  listItems: HorizontalListData[];
  isProvisionalDocument: boolean;
  readonly UCCFilingStatusLabels = UCCFilingStatusLabels;
  readonly UCCFilingDocumentLabels = UCCFilingDocumentLabels;
  readonly PROVISIONAL_UCC_FILING_DOCUMENT = PROVISIONAL_UCC_FILING_DOCUMENT;

  constructor(
    private readonly adapter: EntityUCCFilingWidgetAdapter,
    private readonly dialog: MatDialog,
    private readonly messageService: MessageService,
    private readonly entityAPIFacade: EntityAPIFacade,
  ) {}

  ngOnChanges(): void {
    this.setUCCFiling(this.uccFiling ?? DEFAULT_UCC_FILING_DATA);
  }

  onClickResubmitUCC1Filing(): void {
    SimpleDialogComponent.show(
      this.dialog,
      getInitializeUCC1DialogData(),
    ).subscribe((result: string) => {
      if (result === CommonActionKey.Confirm) {
        this.entityAPIFacade.initialize(this.entityId).subscribe((res: UCCFilingData) => {
          this.setUCCFiling(res);
          this.messageService.success("UCC-1 filing resubmitted");
        });
      }
    });
  }

  onClickRefreshUCC1(): void {
    this.entityAPIFacade.refresh(this.entityId).subscribe((res: UCCFilingData) =>  {
      this.setUCCFiling(res);
      this.messageService.success("UCC-1 refreshed successfully");
    });
  }

  onClickDownloadUCC1Document(): void {
    this.entityAPIFacade.downloadDocument(this.uccFiling.document.id);
  }

  private setUCCFiling(uccFiling: UCCFilingData): void {
    this.uccFiling = uccFiling;
    this.listItems = this.adapter.adaptListData(this.uccFiling, this.canResubmitUCC);
    this.isProvisionalDocument = this.uccFiling?.document?.isFinal === false;
  }
}
